module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_txt02_02-c83c0ae0c61a630400318174d018281a.webp";